import React from 'react';
import remoteFiles from '../../../../../common/remote_files';

const MainPlan = ({ plan, onBack, onSelect, onMorePlans }) => (
  <div className="main-plan">
    <header className="sticky-header bolder">
      <button className="back-button" onClick={ onBack }>
        <span className="dash" />
      </button>
    </header>
    <div className="main-plan-content">
      <div className="plan-card grid-col">
        <div className="col1">
          { plan.bestValue && <div className="badge">Recommended</div> }
          <h1 className="plan-title">{ plan.title }</h1>
          <p className="plan-price">{ plan.price }</p>
          <div className="image-container">
            <img
              src={ remoteFiles.verizon.dynamicOffer.conceptCarousel.mainPlanImage }
              alt="Promotional"
              className="promo-image"
            />
          </div>
          <div className="plan-details">{ plan.description }</div>
          <div className="plan-note">{ plan.note }</div>
        </div>
        <p className="asterisk-note">
          * Plus taxes and Verizon surcharges. Your Cloud plan will auto-renew at
          the monthly charge until you cancel. Cancel anytime in Verizon Cloud app.
        </p>
        <div className="col2">
          <div className="buttons">
            <button className="button" onClick={ onSelect }>Sign up</button>
            <button className="button alt-button" onClick={ onMorePlans }>More plans</button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MainPlan;
